import dayjs from 'dayjs'
import {t} from 'i18next'
import {Person} from '../../../../model/person.model'

export const getBirthdate = (birthdate: Date | null | undefined) => {
	if (birthdate) {
		return dayjs(birthdate).format(t<string>('locales.dateFormat'))
	}
	return t<string>('core.no_specification')
}

export const getStreet = (p: Person | undefined) => {
	if (!p?.street) {
		return t<string>('core.no_specification')
	}

	let street = p.street

	if (p.street_number) {
		street += ` ${p.street_number}`
	}
	return street
}


export const getCity = (p: Person | undefined) => {
	if (!p?.city) {
		return t<string>('core.no_specification')
	}

	let city = p.city

	if (p.postal_code) {
		city = `${p.postal_code} ` + city 
	}
	return city
}